import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed, theme } from "@product/scmp-sdk";

import { BaseLink } from "shared/components/common/base-link";

import { Container as ContentItemPlusHighlightContainer } from "scmp-app/components/content/content-item-render/variants/plus-widget-highlight/styles";
import { PlusWidgetTheme } from "scmp-app/components/plus/plus-widget";
import IconArrow from "scmp-app/components/plus/plus-widget/plus-widget-news-agenda/icon-arrow.svg";
import { PlusWidgetLightThemeStyle } from "scmp-app/components/plus/plus-widget/styles";

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MoreOnLink = styled(BaseLink)`
  display: flex;
  gap: 4px;
  align-items: center;

  margin-block-start: 16px;

  color: #8ab2ff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16.41px;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledIconArrow = styled(IconArrow)``;

type ContainerProps = {
  $plusWidgetTheme: PlusWidgetTheme;
};
export const Container = styled.div<ContainerProps>`
  ${props =>
    props.$plusWidgetTheme === PlusWidgetTheme.LIGHT &&
    css`
      display: block;
      ${ContentContainer} {
        display: block;
        ${PlusWidgetLightThemeStyle.SeparatorEnd}
      }
      ${ContentItemPlusHighlightContainer} + ${ContentItemPlusHighlightContainer} {
        ${PlusWidgetLightThemeStyle.SeparatorStart}
      }
      ${MoreOnLink} {
        display: inline-block;

        margin-block-start: 0;
        padding-block: 7px;
        padding-inline: 8px;

        color: #4585ff;
        font-weight: 400;
        font-size: 14px;
        font-family: ${fontRoboto};
        line-height: normal;
        text-transform: uppercase;

        border: 1px solid #4585ff;
        border-radius: 2px;
        &:hover {
          text-decoration: none;
        }
      }
      ${StyledIconArrow} {
        display: none;
      }
      ${theme.breakpoints.between("tablet", "desktop")} {
        ${ContentContainer} {
          display: flex;
          flex-direction: row;
          gap: 28px;
        }
        ${ContentItemPlusHighlightContainer} + ${ContentItemPlusHighlightContainer} {
          margin-block-start: unset;
          padding-block-start: unset;

          border: unset;
        }
      }
    `}
`;
